import { StateCreator } from 'zustand';
import { IApiContactUpdateDetailDto } from '@/services/swagger/gator/models';
import { getContactEmailGet } from '@/services/swagger/easourcing/ContactService';
import { IApiSourcingContactEmail } from '@/services/swagger/easourcing/models';

export interface SupplierDetailState {
  contactData: IApiSourcingContactEmail | null;
  contactFetchLoading: boolean;
}

export interface SupplierDetailActions {
  fetchContactData: (contactId: string, reload: boolean, showLoading: boolean) => void;
  updateContact: (data: Partial<IApiContactUpdateDetailDto>) => void;
}

export type SupplierDetailSlice = SupplierDetailState & SupplierDetailActions;

let latestFetchId = 0;

export const createSupplierDetailSlice: StateCreator<SupplierDetailSlice, [], [], SupplierDetailSlice> = (
  set,
  get
) => ({
  contactData: null,
  contactFetchLoading: true,
  fetchContactData(contactId: string, reload = false, showLoading = false) {
    const { contactData } = get();
    if (!reload && contactData) {
      return Promise.resolve();
    }

    if (showLoading) {
      set({ contactFetchLoading: true });
      set({ contactData: null });
    }

    const fetchId = ++latestFetchId;

    return getContactEmailGet({ contactId }, { skipGlobalErrorHandling: true })
      .then(res => {
        // 仅当此请求仍为最新请求时才更新状态，避免竞态覆盖
        if (fetchId === latestFetchId) {
          set({ contactData: res });
        }
      })
      .finally(() => {
        if (fetchId === latestFetchId) {
          set({ contactFetchLoading: false });
        }
      });
  },
  updateContact: (data: Partial<IApiContactUpdateDetailDto>) => {
    const { contactData } = get();

    if (!contactData) {
      return;
    }

    set({
      contactData: {
        ...contactData,
        ...data,
      },
    });
  },
});
